function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import * as React from "react";
import { useEffect, useState } from "react";
import Select from "react-select/creatable";

var Step2 = function Step2(props) {
  var claim = props.claim,
      onChangeClaim = props.onChangeClaim;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      claimsSettlementCompanies = _useState2[0],
      setClaimsSettlementCompanies = _useState2[1];

  var _useState3 = useState(true),
      _useState4 = _slicedToArray(_useState3, 2),
      loading = _useState4[0],
      setLoading = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      error = _useState6[0],
      setError = _useState6[1];

  useEffect(function () {
    var fetchClaimsSettlementCompanies = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var response, data;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                setLoading(true);
                _context.next = 4;
                return fetch('/api/v1/claims_settlement_companies');

              case 4:
                response = _context.sent;

                if (response.ok) {
                  _context.next = 7;
                  break;
                }

                throw new Error("HTTP error! status: ".concat(response.status));

              case 7:
                _context.next = 9;
                return response.json();

              case 9:
                data = _context.sent;
                setClaimsSettlementCompanies(data);
                setError(null);
                _context.next = 18;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context["catch"](0);
                console.error('Error fetching claims settlement companies:', _context.t0);
                setError('Error al cargar las empresas liquidadoras');

              case 18:
                _context.prev = 18;
                setLoading(false);
                return _context.finish(18);

              case 21:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 14, 18, 21]]);
      }));

      return function fetchClaimsSettlementCompanies() {
        return _ref.apply(this, arguments);
      };
    }();

    fetchClaimsSettlementCompanies();
  }, []);

  var handleAnyInspection = function handleAnyInspection() {
    onChangeClaim(_objectSpread(_objectSpread({}, claim), {}, {
      any_inspection: !claim.any_inspection
    }));
  };

  var businessOptions = claimsSettlementCompanies.map(function (company) {
    return {
      label: company.name,
      value: company.name,
      data: company // Store full company data for potential future use

    };
  });

  var handleSelectorChange = function handleSelectorChange(item) {
    onChangeClaim(_objectSpread(_objectSpread({}, claim), {}, {
      business_name: (item === null || item === void 0 ? void 0 : item.value) || ''
    }));
  };

  var selectedBusinessName = businessOptions.find(function (company) {
    return company.value === claim.business_name;
  }) || {
    label: claim.business_name,
    value: claim.business_name
  };

  if (loading) {
    return /*#__PURE__*/React.createElement("div", {
      className: "step"
    }, /*#__PURE__*/React.createElement("div", {
      className: "row"
    }, /*#__PURE__*/React.createElement("div", {
      className: "col-md-12"
    }, /*#__PURE__*/React.createElement("div", {
      className: "text-center"
    }, /*#__PURE__*/React.createElement("p", null, "Cargando empresas liquidadoras...")))));
  }

  if (error) {
    return /*#__PURE__*/React.createElement("div", {
      className: "step"
    }, /*#__PURE__*/React.createElement("div", {
      className: "row"
    }, /*#__PURE__*/React.createElement("div", {
      className: "col-md-12"
    }, /*#__PURE__*/React.createElement("div", {
      className: "alert alert-danger"
    }, error))));
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "step"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-4"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Raz\xF3n Social"), /*#__PURE__*/React.createElement(Select, {
    options: businessOptions,
    value: selectedBusinessName,
    placeholder: "Seleccionar empresa liquidadora...",
    onChange: handleSelectorChange,
    isClearable: true,
    isLoading: loading,
    noOptionsMessage: function noOptionsMessage() {
      return "No se encontraron empresas liquidadoras";
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-4"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Nombre"), /*#__PURE__*/React.createElement("input", {
    className: "form-control inputAddress",
    value: claim.name || "",
    onChange: function onChange(event) {
      onChangeClaim(_objectSpread(_objectSpread({}, claim), {}, {
        name: event.target.value
      }));
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-4"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "\xBFHay Inspecci\xF3n?"), /*#__PURE__*/React.createElement("div", {
    className: "checkbox-wrapper-17"
  }, /*#__PURE__*/React.createElement("input", {
    className: "check",
    type: "checkbox",
    id: "switch-17",
    checked: claim.any_inspection,
    onChange: handleAnyInspection
  }), /*#__PURE__*/React.createElement("label", {
    htmlFor: "switch-17"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-4"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Email"), /*#__PURE__*/React.createElement("input", {
    className: "form-control inputAddress",
    value: claim.email || "",
    onChange: function onChange(event) {
      onChangeClaim(_objectSpread(_objectSpread({}, claim), {}, {
        email: event.target.value
      }));
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-4"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Tel\xE9fono"), /*#__PURE__*/React.createElement("input", {
    className: "form-control inputAddress",
    value: claim.phone || "",
    onChange: function onChange(event) {
      onChangeClaim(_objectSpread(_objectSpread({}, claim), {}, {
        phone: event.target.value
      }));
    }
  }))))));
};

export default Step2;